import React from "react";
import PropTypes from "prop-types";
import SFChip from "../chip";
import useStyled from "../../hooks/useStyled";

const { styled } = useStyled();

const SFChipStyled = styled(SFChip, {
  shouldForwardProp: (prop) =>
    prop !== "bgColorName" && prop !== "active" && prop !== "inDrawer",
})(({ theme, bgColorName, active, disabled, inDrawer }) => ({
  backgroundColor: active
    ? theme.palette[bgColorName].main
    : "rgba(116, 116, 128, 0.20)",
  borderRadius: 5,
  outline: `1px solid ${
    active ? theme.palette[bgColorName].main : theme.palette.grey400.main
  }`,
  ...(!disabled && {
    "&:hover": {
      backgroundColor: theme.palette[bgColorName].main,
      "& .MuiChip-label": {
        color: theme.palette.white.main,
      },
    },
  }),
  cursor: "pointer",
  minWidth: inDrawer ? 100 : 170,
  width: "100%",
  height: 25,
  "& .MuiChip-label": {
    ...theme.typography.body2bold,
    color: active ? theme.palette.white.main : theme.palette.grey350.main,
    fontSize: 12,
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

const Pill = ({ children, color, active, disabled, inDrawer = false }) => {
  return (
    <SFChipStyled
      bgColorName={color}
      active={active}
      disabled={disabled}
      inDrawer={inDrawer}
    >
      {children}
    </SFChipStyled>
  );
};

Pill.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  inDrawer: PropTypes.bool,
};

export default Pill;
